import classNames from "classnames";
import checkboxFilledIcon from "../../../../assets/checkbox-filled.svg";
import checkboxUnfilledIcon from "../../../../assets/checkbox-unfilled.svg";
import checkboxFilledDisabledIcon from "../../../../assets/checkbox-filled-disabled.svg";
import checkboxUnfilledDisabledIcon from "../../../../assets/checkbox-unfilled-disabled.svg";
import styles from "./StyledCheckbox.module.css";

const strings = {
  checked: "Checked",
  unchecked: "Unchecked",
};

type Props = React.ComponentProps<"input"> & {
  iconClassName?: string;
  labelClassName?: string;
} & (
    | {
        label: string;
        "aria-label"?: never;
      }
    | {
        label?: never;
        "aria-label": string;
      }
  );

export default function StyledCheckbox({
  className,
  iconClassName,
  labelClassName,
  label,
  ...props
}: Props) {
  let src = props.disabled
    ? checkboxUnfilledDisabledIcon
    : checkboxUnfilledIcon;
  if (props.checked) {
    src = props.disabled ? checkboxFilledDisabledIcon : checkboxFilledIcon;
  }
  return (
    <label className={classNames(styles.label, className)}>
      <input {...props} className={styles.input} type="checkbox" />
      <img
        className={iconClassName}
        src={src}
        alt={props.checked ? strings.checked : strings.unchecked}
      />
      {label && <span className={labelClassName}>{label}</span>}
    </label>
  );
}
